import { useExperimentTakeover } from 'modules/experiments/takeover';
import { ExperimentTakeoverSource } from 'modules/experiments/takeover/constants';
import { BUTTON_SIZES, Button } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import {
  SpaceSeparatedList,
  SpaceSeparatedListItem,
  StyledButtonLink,
} from '../../components/Sections/Sections.styled';
import { ModalType, useModalContext } from '../../context';
import { useSendTimeExperiment } from '../../hooks';
import { useSendSendTimeExperimentCampaign } from './useSendSendTimeExperimentCampaign';

export const SEND_SEND_TIME_EXPERIMENT_CAMPAIGN_MODAL_TEST_ID = 'send-send-time-experiment-modal';
export const SEND_SEND_TIME_EXPERIMENT_CAMPAIGN_CONFIRM_BUTTON_TEST_ID =
  'send-send-time-experiment-modal-button';

export const SendTimeExperimentCampaignModal = () => {
  const { closeModal } = useModalContext();
  const { isLoading, sendSendTimeExperimentCampaign } = useSendSendTimeExperimentCampaign();
  const { sendTimeExperiments } = useSendTimeExperiment();
  const { getExperimentLinkAttributes } = useExperimentTakeover();

  return (
    <Modal
      withPortal
      isModalOpen={true}
      onClose={() => closeModal(ModalType.SendTimeExperimentCampaignModal)}
      id={SEND_SEND_TIME_EXPERIMENT_CAMPAIGN_MODAL_TEST_ID}
      data-test={SEND_SEND_TIME_EXPERIMENT_CAMPAIGN_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Send campaign?</ModalHeader>
      <ModalBody>
        Are you sure you want to send your campaign? This campaign has a send time experiment and
        will send based on your experiment settings.
        <br />
        <br />
        <SpaceSeparatedList data-test="experiments-container">
          {sendTimeExperiments?.map((experiment) => {
            const { name, id: experimentId } = experiment;
            const experimentAttributes = getExperimentLinkAttributes({
              source: ExperimentTakeoverSource.CAMPAIGN_EDITOR,
              experiment,
              onClickCallback: () => closeModal(ModalType.SendTimeExperimentCampaignModal),
            });

            return (
              <SpaceSeparatedListItem key={`${experimentId}-${name}`}>
                <StyledButtonLink
                  data-test={`experiment-${experimentId}`}
                  {...experimentAttributes}
                >
                  {name}
                </StyledButtonLink>
              </SpaceSeparatedListItem>
            );
          })}
        </SpaceSeparatedList>
      </ModalBody>
      <ModalFooter>
        <Button
          data-test={SEND_SEND_TIME_EXPERIMENT_CAMPAIGN_CONFIRM_BUTTON_TEST_ID}
          onClick={sendSendTimeExperimentCampaign}
          isDisabled={isLoading}
          isLoading={isLoading}
          size={BUTTON_SIZES.LARGE}
        >
          Send campaign
        </Button>
      </ModalFooter>
    </Modal>
  );
};
